import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type HistoryBubbleTableDataObject } from '../types'

export interface HistoryBubbleTableState {
  isLoading: boolean
  errorMessage: string | undefined
  data: HistoryBubbleTableDataObject | undefined
  httpStatus: number
}

const initialState: HistoryBubbleTableState = {
  isLoading: true,
  errorMessage: undefined,
  data: undefined,
  httpStatus: 0
}

const historyBubbleTableSlice = createSlice({
  name: 'KpiHistoryBubbleTable',
  initialState,
  reducers: {
    historyBubbleTableLoadingAction: (state) => {
      return {
        isLoading: true,
        errorMessage: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    historyBubbleTableUpdateAction: (state, action: PayloadAction<{ data: HistoryBubbleTableDataObject, httpStatus: number }>) => {
      return {
        isLoading: false,
        errorMessage: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    historyBubbleTableErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    historyBubbleTableResetAction: () => {
      return initialState
    }
  }
})

export const {
  historyBubbleTableLoadingAction,
  historyBubbleTableUpdateAction,
  historyBubbleTableErrorAction,
  historyBubbleTableResetAction
} = historyBubbleTableSlice.actions

export default historyBubbleTableSlice.reducer
